import { render, staticRenderFns } from "./unit_table.vue?vue&type=template&id=45442e0d&scoped=true&"
import script from "./unit_table.vue?vue&type=script&lang=js&"
export * from "./unit_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45442e0d",
  null
  
)

export default component.exports